import { render, staticRenderFns } from "./originality.vue?vue&type=template&id=598399aa&scoped=true"
import script from "./originality.vue?vue&type=script&lang=js"
export * from "./originality.vue?vue&type=script&lang=js"
import style0 from "./originality.vue?vue&type=style&index=0&id=598399aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598399aa",
  null
  
)

export default component.exports